import PropTypes from 'prop-types';
import { Table, Pagination } from 'antd';
import { getTableColumnsIDSO, getTableColumnsCandidatosAprobados } from './ColumnsTableIdSO';

export const TableIdentificacionSO = ({ tableControls, headerTable }) => {
  const isTableBeneficiados = headerTable === 'Beneficiados';

  const { dataSource, onPageChange, currentPage, onCheckChange, total } = tableControls;
  const { loading, onFilterChange, filters, onEnterPress } = tableControls;

  const columns = isTableBeneficiados
    ? getTableColumnsIDSO(onCheckChange, onFilterChange, filters, onEnterPress)
    : getTableColumnsCandidatosAprobados(onCheckChange, onFilterChange, filters, onEnterPress);

  const rowClassName = (row) => {
    // asigna los estilos del checkbox seleccionado
    return row?.asociar ? 'row-checked-candidatos-aprobados' : '';
  };

  return (
    <div className="custom-table">
      <div className="title-instructions-id-dotable">
        <span className="title-id-so-table">
          {isTableBeneficiados ? 'Beneficiados' : 'Sujetos Obligados Aprobados'}
        </span>
        <br />
        <span className="instructions-id-so-table">
          {isTableBeneficiados
            ? 'Beneficiados capturados manualmente que no cuentan con el identificador del SO.'
            : 'Sujetos Obligados registrados en SNR y/o SIRCF y sus respectivos Resposables de Finanzas (RF).'}
        </span>
      </div>
      <Table
        key={isTableBeneficiados ? 'Beneficiados' : 'Sujetos Obligados Aprobados'}
        rowClassName={rowClassName}
        pagination={false}
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        scroll={{ x: 1120, y: 290 }}
      />
      <div style={{ margin: '30px' }}>
        {total > 0 ? (
          <Pagination
            align="end"
            showQuickJumper
            current={currentPage}
            total={total}
            onChange={onPageChange}
            showSizeChanger={false}
            showTotal={(totalPrev, range) =>
              totalPrev === 1
                ? `Mostrando 1 registro`
                : `Mostrando del ${range[0]} al ${range[1]} de ${total} registros`
            }
          />
        ) : null}
      </div>
    </div>
  );
};

TableIdentificacionSO.propTypes = {
  tableControls: PropTypes.shape({
    dataSource: PropTypes.arrayOf({
      idBeneficiado: PropTypes.string.isRequired,
      nombreBeneficiado: PropTypes.string.isRequired,
      sujetoObligado: PropTypes.number.isRequired,
      entidad: PropTypes.string.isRequired,
      tipoBeneficio: PropTypes.string.isRequired,
      folioMonitoreo: PropTypes.string.isRequired
    }),
    onPageChange: PropTypes.func.isRequired,
    currentPage: PropTypes.number.isRequired,
    onCheckChange: PropTypes.func.isRequired,
    total: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    filters: PropTypes.shape({
      nombreCandidato: PropTypes.string.isRequired,
      estado: PropTypes.string.isRequired,
      cuentaRF: PropTypes.string.isRequired,
      correoRF: PropTypes.string.isRequired
    }),
    onEnterPress: PropTypes.func.isRequired
  }).isRequired,
  headerTable: PropTypes.string.isRequired
};
